// src/features/welfare/welfare-routes.tsx
import * as React from "react";
import { type RouteObject } from "react-router-dom";
import { WelfareLayout } from "./ui/screens/welfare-layout";
import { WelfareInstancesScreen } from "./ui/screens/welfare-instances-screen";
import { WelfareDefinitionsScreen } from "./ui/screens/welfare-definitions-screen";
import { WelfareDefinitionPoliciesScreen } from "./ui/screens/welfare-definitions-policies-screen";

export function getWelfareRoutesDefinitions(): RouteObject[] {
  return [
    {
      element: <WelfareLayout />,
      children: [
        { index: true,       element: <WelfareInstancesScreen /> },
        { path: "instances", element: <WelfareInstancesScreen /> },
        {
          path: "definitions",
          element: <WelfareDefinitionsScreen />,
          children: [
            { path: ":definitionId", element: <WelfareDefinitionPoliciesScreen /> }
          ]
        }
      ]
    }
  ];
}
